var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppSettings } from 'app/app.settings';
import { BehaviorSubject } from 'rxjs';
import { CommonRequestService } from './common-request.service';
import { ResolutionCenterService } from './resolution-center.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-request.service";
import * as i2 from "./resolution-center.service";
var ResolutionCenterDomainService = /** @class */ (function () {
    function ResolutionCenterDomainService(requestService, resoCenterService) {
        this.requestService = requestService;
        this.resoCenterService = resoCenterService;
        this.resoFeedDomainBS = new BehaviorSubject({
            layerId: null,
            feeds: null
        });
        this.domainValuesByRule = {};
    }
    ResolutionCenterDomainService.prototype.getQaResolverFeedsDomain = function (layerId, layerCateCode) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/rcFeedDomain';
            var params = {
                layerId: layerId
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) { return __awaiter(_this, void 0, void 0, function () {
                var feeds, promises_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            feeds = [];
                            if (!rsp.data) return [3 /*break*/, 2];
                            promises_1 = [];
                            rsp.data.forEach(function (i) {
                                var promise = new Promise(function (resolveP, rejectP) { return __awaiter(_this, void 0, void 0, function () {
                                    var colsByName, cols, colsWithCount, feed;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                colsByName = i.col_cnt;
                                                return [4 /*yield*/, this.resoCenterService.transformCols(Object.keys(colsByName), layerCateCode)];
                                            case 1:
                                                cols = _a.sent();
                                                colsWithCount = cols.map(function (c) {
                                                    return Object.assign({
                                                        count: colsByName[c.standardName]
                                                    }, c);
                                                });
                                                feed = {
                                                    rule: i.gqr_cd,
                                                    count: i.rul_cnt,
                                                    cols: colsWithCount
                                                };
                                                feeds.push(feed);
                                                resolveP();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                                promises_1.push(promise);
                            });
                            return [4 /*yield*/, Promise.all(promises_1)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            resolve(feeds);
                            return [2 /*return*/];
                    }
                });
            }); }, function (err) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, reject(err)];
            }); }); });
        });
    };
    ResolutionCenterDomainService.prototype.getQaResolverFeedsDomainValues = function (layerId, ruleCode, columnName, colProp) {
        var _this = this;
        // ruleCode = 'MSV';
        // columnName = 'IncMuni_L';
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/rcFeedDomain';
            var params = {
                layerId: layerId,
                ruleCode: ruleCode,
                columnName: columnName
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var list = [];
                if (rsp.data) {
                    rsp.data.forEach(function (i) {
                        list.push({
                            value: i[colProp],
                            count: i.cnt,
                            isValid: true
                        });
                    });
                }
                _this.domainValuesByRule[ruleCode][colProp] = list;
                resolve(list);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, reject(err)];
            }); }); });
        });
    };
    ResolutionCenterDomainService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ResolutionCenterDomainService_Factory() { return new ResolutionCenterDomainService(i0.ɵɵinject(i1.CommonRequestService), i0.ɵɵinject(i2.ResolutionCenterService)); }, token: ResolutionCenterDomainService, providedIn: "root" });
    return ResolutionCenterDomainService;
}());
export { ResolutionCenterDomainService };
